import { makeStyles } from '@mui/styles';
import { COLORS } from './palette';
const useStyles = makeStyles({
  root: {
    background: COLORS.appBg,
    borderRadius: 12,
    padding: '20px 20px 28px'
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    flexWrap: 'wrap',
    marginBottom: 16
  },
  title: {
    margin: 0,
    fontSize: 22,
    fontWeight: 700,
    color: COLORS.text
  },
  subtitle: {
    margin: '4px 0 0',
    fontSize: 13,
    color: COLORS.textMuted,
    maxWidth: 620
  },
  filters: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 12,
    alignItems: 'center',
    marginBottom: 20
  },
  mdSelector: {
    minWidth: 220
  },
  smSelector: {
    minWidth: 170
  },
  // KPI row — auto-fit cards, wraps gracefully on narrow widths.
  kpiRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: 12,
    marginBottom: 16
  },
  // 12-column panel grid.
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gap: 14,
    '@media (max-width: 900px)': {
      gridTemplateColumns: 'repeat(6, 1fr)'
    }
  },
  toggleRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 4
  },
  // Dense receipts table.
  tableWrap: {
    overflowX: 'auto',
    border: "1px solid ".concat(COLORS.border),
    borderRadius: 8
  },
  // Scrollable variant — caps a long table to a window with a sticky header so the
  // page doesn't grow to thousands of rows. Pair with `tableWrap`. Stickiness is scoped
  // here (not on the base table) so non-scrolling tables don't stick on page scroll.
  tableScroll: {
    maxHeight: 440,
    overflowY: 'auto',
    '& th': {
      position: 'sticky',
      top: 0,
      zIndex: 1
    }
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 13,
    '& th': {
      textAlign: 'left',
      padding: '10px 14px',
      color: COLORS.textFaint,
      fontWeight: 600,
      textTransform: 'uppercase',
      fontSize: 11,
      letterSpacing: 0.5,
      borderBottom: "1px solid ".concat(COLORS.border),
      background: COLORS.appBg,
      whiteSpace: 'nowrap'
    },
    '& td': {
      padding: '10px 14px',
      color: COLORS.text,
      borderBottom: "1px solid ".concat(COLORS.border),
      whiteSpace: 'nowrap'
    },
    '& tbody tr:last-child td': {
      borderBottom: 'none'
    },
    '& tbody tr:hover td': {
      background: 'rgba(0,146,153,0.04)'
    }
  },
  num: {
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums'
  }
});
export default useStyles;